import React from 'react';
import { Container } from 'react-bootstrap';

function Firstaboutimg() {

  const imageStyle = {
    objectFit: 'cover',
    width: '100%', // Adjusted to make the image responsive
    maxHeight: '100vh', // Added to limit the image height on small screens
    filter: 'opacity(3) brightness(1)',
  };

  const containerStyle = {
    marginBottom: '10px',
    marginTop: '10px',
    position: 'relative',
    maxWidth: '100%',
    overflow: 'hidden', // Added to hide overflowing content
  };

  const contentContainerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
    color: 'white',
  };
  const captionTextStyle = {
    fontSize:'40px', 
  }

  const mobileCaptionTextStyleh = {
    fontSize: '2rem', // Adjust the font size for mobile
  };
  

  return (
    <Container fluid style={{ margin: '-18px 0 0 0', padding: 0, position: 'relative' }}>
      <div style={containerStyle}>
        <img
          src={process.env.PUBLIC_URL + '/assets/images/AboutBanner.png'}
          className="d-block w-100" // Added img-fluid for responsiveness
          alt=""
          style={imageStyle}
        />
        <div style={contentContainerStyle}>
         <h3 className="text-lg" style={{...mobileCaptionTextStyleh, ...captionTextStyle}}> About Ascent </h3>
        </div>
      </div>
    </Container>
  );
}

export default Firstaboutimg;
